import { SummaryDTO } from '@app/src/views/StepThree/publicationConfirmation/dtos';
import { SummaryModel } from '@app/src/views/StepThree/publicationConfirmation/models';
import { ExtrachargeDTO } from '@app/src/views/StepTwo/channelPublication/dto/TypePublicationDTO';
import { ExtrachargeModel } from '@app/src/views/StepTwo/channelPublication/models/typePublication';
import { EXTRACHARGE } from '@app/src/views/StepTwo/channelPublication/state/typePublication/constants';

export const hydrateSummary = (data: SummaryDTO): SummaryModel => {
  const price = data.price;
  const subTotal = price.sub_total;
  const igv = price.igv;
  const totalIgv = price.igv_total;
  const total = price.total;
  const discount = price.discount;
  const totalDiscount = price.discount_total;
  let operationType, section;

  if (data.extra) {
    const extra = data.extra;
    operationType = extra.operation_type;
    section = extra.section;
  }

  const print = data.print.map((print) => ({
    dates: print.dates_print,
    unitPrice: print.prices[0],
    subTotal: print.sub_total,
    title: print.title,
    text: print.text,
    channel: print.channel,
    day: print.day,
    extracharges: hydrateExtracharge(print.extracharges)
  }));

  const dataHydrate: SummaryModel = {
    price: {
      subTotal,
      igv,
      totalIgv,
      total,
      discount,
      totalDiscount
    },
    extra: {
      operationType,
      section
    },
    print
  };

  return dataHydrate;
};

export const hydrateExtracharge = (data: ExtrachargeDTO[]) => data && data.map(item => {
  if (item.detail) {
    return({
      name: item.name,
      alias: item.alias,
      price: item.price,
      priceIgv: item.price_igv,
      id: item.id,
      tariffCode: item.tariff_code,
      tariffId: item.tariff_id,
      publicationId: item.publication_id,
      quantity: item.quantity,
      style: EXTRACHARGE[item.alias] && EXTRACHARGE[item.alias].style,
      styleValue: EXTRACHARGE[item.alias] && EXTRACHARGE[item.alias].styleValue,
      detail: {
        labelName: item.detail.label_name,
        labelCode: item.detail.code_label,
        photoName: item.detail.photo_name,
        photoPreviewUrl: item.detail.photo_preview_url
      }
    })
  }
  return({
    name: item.name,
    alias: item.alias,
    price: item.price,
    priceIgv: item.price_igv,
    id: item.id,
    tariffCode: item.tariff_code,
    tariffId: item.tariff_id,
    publicationId: item.publication_id,
    quantity: item.quantity,
    style: EXTRACHARGE[item.alias] && EXTRACHARGE[item.alias].style,
    styleValue: EXTRACHARGE[item.alias] && EXTRACHARGE[item.alias].styleValue
  })
}) as ExtrachargeModel[];
